import SubtleBadge from '@/components/common/SubtleBadge';
import { Nav } from 'react-bootstrap';
// تب های تنظیمات خزش
const CrawlSettingsTab = () => {
  return (
    <Nav variant="tabs" className="flex-wrap crawl-settings-drawer__nav">
      <Nav.Item>
        <Nav.Link
          eventKey="crawlerSetting"
          className="navLinkForceColor ps-0 cursor-pointer outline-none"
        >
          قوانین خزش
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="crawlerAssets"
          className="navLinkForceColor px-2 px-md-3 cursor-pointer outline-none"
        >
          منابع
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="crawlerLimit"
          className="navLinkForceColor px-2 px-md-3 cursor-pointer outline-none"
        >
          محدودیت
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="crawlerContent"
          className="navLinkForceColor px-2 px-md-3 cursor-pointer outline-none"
        >
          محتوا
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="crawlerUserAgent"
          className="navLinkForceColor px-2 px-md-3 cursor-pointer outline-none"
        >
          یوزر ایجنت
        </Nav.Link>
      </Nav.Item>

      <Nav.Item>
        <Nav.Link
          eventKey="crawlerIncludeExclude"
          className="navLinkForceColor px-2 px-md-3 cursor-pointer outline-none"
        >
          شامل و استثنا
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          disabled
          eventKey="crawlerSchedule"
          className="navLinkForceColor px-2 px-md-3 outline-none disabled-link d-inline-flex align-items-center gap-1 crawl-settings-tab--soon"
        >
          زمان‌بندی
          <SubtleBadge bg="info" className="fs--2 crawl-settings-tab__soon-badge">
            به زودی
          </SubtleBadge>
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default CrawlSettingsTab;
